import vSelect from 'vue-select'

<template>
  <v-dialog
      v-model="dialog"
      scrollable
      data-testid="app-modal-dialog"
      @click:outside="onClickOutside"
  >
    <v-card data-testid="app-modal-card" @mousedown.stop @click.stop>
      <v-overlay
          v-if="loading"
          contained
          :model-value="true"
          class="align-center justify-center"
          persistent
          scrim
      >
        <v-progress-circular
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>
      <v-toolbar color="primary" dark>
        <v-toolbar-title>{{computedTitle}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon variant="text" data-testid="app-modal-close" @click="close">
          <v-icon>far fa-window-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-toolbar v-if="$slots.tabs" color="white" style="margin-bottom: 30px;">
        <slot name="tabs"></slot>
      </v-toolbar>
      <v-card-text>
        <v-container fluid>
              <row>
                <col12>
                  <slot name="content"></slot>
                </col12>
              </row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <slot name="buttons"></slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Col12 from "@/components/layout/Col12";
import Row from "@/components/layout/Row";
import { blockAnnotateModalOpen } from '@/utils/annotateModalGuard';
export default {
  components: {Row, Col12},
  props: {
    'loading': {default: false},
    'title': {default: null}
  },
  computed: {
    translatedTitle() {
      return this.$t('set_label_groups.default_title');
    },
    computedTitle() {
      return this.title !== null ? this.title : this.translatedTitle;
    }
  },
  data () {
    return {
      'dialog': true
    }
  },
  watch: {
    dialog(isOpen) {
      if (!isOpen) {
        blockAnnotateModalOpen();
        this.$emit('close_modal');
      }
    },
  },
  methods: {
    onClickOutside(event) {
      if (event && typeof event.preventDefault === 'function') {
        event.preventDefault();
      }
      if (event && typeof event.stopPropagation === 'function') {
        event.stopPropagation();
      }
      blockAnnotateModalOpen();
      this.close();
    },
    close() {
      blockAnnotateModalOpen();
      this.dialog = false;
    },
  },
}
</script>

<style scoped>
</style>
